import { ProviderSessionsCard } from "../../provider-sessions/ProviderSessionsCard";
import { PendingExtensionRequests } from "../../provider-sessions/PendingExtensionRequests";
import { useProviderWorkspace } from "../ProviderWorkspaceContext";

export function FloorSection() {
  const {
    creatingWalkIn,
    sessionError,
    sessionsLoading,
    sessionNotice,
    startWalkInSession,
    extendSession,
    openSessionCheckout,
    stopSession,
    extendingSessionId,
    recentSessions,
    selectedVenue,
    sessions,
    stoppingSessionId,
    isOnline,
    user,
    summary,
    notificationTarget,
    reloadSessions,
    syncOperationalState,
  } = useProviderWorkspace();

  return (
    <div className="grid gap-4">
      {selectedVenue && <PendingExtensionRequests
        selectedVenue={selectedVenue}
        authority={{ userId: user?.id ?? null, userRole: user?.role ?? null, membershipRole: summary?.membership_role ?? null, providerStatus: summary?.provider_status ?? null }}
        isOnline={isOnline}
        notificationSessionId={notificationTarget?.kind === "session" ? notificationTarget.sessionId : null}
        onSessionChanged={async () => { await Promise.all([reloadSessions(), syncOperationalState()]); }}
      />}
      <ProviderSessionsCard
        creatingWalkIn={creatingWalkIn}
        error={sessionError}
        isLoading={sessionsLoading}
        notice={sessionNotice}
        onStartWalkInSession={async (payload) => Boolean(await startWalkInSession(payload))}
        onExtendSession={async (sessionId, additionalMinutes) => {
          await extendSession(sessionId, {
            additional_minutes: additionalMinutes,
          });
        }}
        onCheckoutSession={openSessionCheckout}
        onStopSession={async (sessionId, payload) => {
          const stoppedSession = await stopSession(sessionId, payload);
          if (stoppedSession) {
            openSessionCheckout(stoppedSession.id);
          }
        }}
        extendingSessionId={extendingSessionId}
        recentSessions={recentSessions}
        selectedVenue={selectedVenue}
        sessions={sessions}
        stoppingSessionId={stoppingSessionId}
      />
    </div>
  );
}
